export type UnsuccessfulFetchErrorOptions = {
	readonly message?: string;
	readonly response: Response;
};

export class UnsuccessfulFetchError extends Error {
	public readonly response: Response;

	public constructor({ message, response }: UnsuccessfulFetchErrorOptions) {
		super(message ?? response.statusText);
		this.name = UnsuccessfulFetchError.name;
		this.response = response;
	}

	public get url(): string {
		return this.response.url;
	}

	public get status(): number {
		return this.response.status;
	}
}

export function isUnsuccessfulFetchError(value: unknown): value is UnsuccessfulFetchError {
	return (value as UnsuccessfulFetchError).name === UnsuccessfulFetchError.name;
}
